// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html,
#root {
  font-family: "Rubik";
  width: 100%;
  height: 100%;
}

::-webkit-scrollbar {
  width: 0px;
}

* {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.form-input {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin: 0.5em;
}
.form-input input {
  padding: 0.64em;
  border-radius: 0.3em;
  border: 1px solid #dcdcdc;
  margin-top: 0.3em;
}
.form-input input:active, .form-input input:focus {
  box-shadow: none;
  border-color: #8f003c;
}
.form-input select {
  padding: 0.4em;
  border-radius: 0.3em;
  border: 1px solid #dcdcdc;
  margin-top: 0.3em;
}
.form-input select:active, .form-input select:focus {
  box-shadow: none;
  border-color: #8f003c;
}
.form-select-custom {
  border-radius: 0.5em;
  margin-top: 0.3em;
  width: 100%;
}
.form-select-custom-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5em;
}
.form-select-custom-label-secondary {
  color: #777776;
}
.form-area {
  width: 100%;
  margin: 0.5em;
}
.form-area textarea:not(.w-md-editor-text-input) {
  padding: 1em;
  border-radius: 0.5em;
  border: 1px solid #dcdcdc;
  margin-top: 0.3em;
  min-height: 11em;
  max-height: 11em;
}
.form-area textarea:not(.w-md-editor-text-input):active, .form-area textarea:not(.w-md-editor-text-input):focus {
  box-shadow: none;
  border-color: #8f003c;
}
.form-check {
  margin: 0.5em !important;
}
.form-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.form-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1;
}
.form-action, .form-action:focus, .form-action:hover, .form-action:active {
  align-self: flex-end;
  outline: none;
  box-shadow: none !important;
  background-color: #fff;
  border: 1px solid #8f003c;
  color: #8f003c;
  padding-inline: 2em;
}
.form-action-primary {
  background-color: #8f003c !important;
  color: #fff !important;
}
.form-action-secondary {
  background-color: #fff !important;
  color: #4e7da2 !important;
  border: #4e7da2 1px solid !important;
}
.form-action-cancel {
  background-color: inherit !important;
  color: #777776 !important;
  text-decoration: underline;
  border: none;
  outline: none;
  box-shadow: none !important;
}
.form-action-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 1em;
}
.form-action:hover {
  background-color: #8f003c;
  color: #fff;
}
.form-radio-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}
.pagination-container > li > a, .pagination-container > li > a:hover, .pagination-container > li > a:active, .pagination-container > li > a:focus {
  color: #920942;
  box-shadow: none;
  outline: none;
  border: none;
  background-color: inherit;
  padding: 6px;
  border-radius: 0 !important;
  box-sizing: border-box;
}
.pagination-container-selected {
  color: #777776 !important;
  border-bottom: 1px solid #920942;
}

.nav {
  color: #777776;
}
.nav-link, .nav-link:hover {
  color: #777776;
}
.nav-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-bottom: 1px solid #f3f6f9 !important;
  color: #777776;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-link:hover {
  border: none;
  color: #8f003c;
  border-bottom: 2px solid #8f003c;
}

.form-check-input-custom input[type=checkbox], .form-check-input-custom input[type=radio] {
  margin: 0.3em;
  cursor: pointer;
}
.form-check-input-custom input[type=checkbox]:checked, .form-check-input-custom input[type=radio]:checked {
  border-color: black;
  background-color: black;
  background-image: none !important;
}
.form-check-input-custom input[type=checkbox]:focus, .form-check-input-custom input[type=radio]:focus {
  outline: none;
  box-shadow: none !important;
  background-image: none !important;
  border-color: black !important;
}

.form-custom-switch {
  display: flex;
  align-items: center;
  gap: 1em;
}
.form-custom-switch input[type=checkbox] {
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.form-custom-switch input[type=checkbox]:checked {
  border-color: #777776 !important;
  background-color: #4e7da2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}
.form-custom-switch input[type=checkbox]:focus {
  outline: none;
  box-shadow: none;
  border-color: #777776 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.check-group-line {
  align-self: center;
  width: 3em;
  margin: 0.6em;
  border-top: 1px solid rgb(234, 234, 239);
}

.draft-badge {
  margin-left: 0.5em;
  cursor: default;
  background-color: #8f003c !important;
}

.input-info-error {
  margin-top: 0.25rem;
  font-size: 0.875em !important;
  color: #dc3545;
  font-weight: normal !important;
}

.form-subgroup {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

button[data-name=checked-list], button[data-name=code] {
  display: none;
}

#react-select-3-listbox {
  z-index: 99999;
}

.copy-clipboard-button {
  background-color: #8f003c;
  color: white;
  border: none;
  outline: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-content: center;
}

.copy-clipboard-button:hover, .copy-clipboard-button:focus {
  background-color: #777776;
  color: white;
  border: none;
  outline: none;
  box-shadow: none;
}

.webpack-dev-server-client-overlay-div,
#webpack-dev-server-client-overlay {
  display: none !important;
}

/* Ensure the form area holding the editor expands natively */
.markdown-form-area .content,
.markdown-form-area .tag {
  display: contents !important;
}

.markdown-form-area .list {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/sass/globals/globals.scss","webpack://./src/sass/globals/mixins.scss"],"names":[],"mappings":"AAGA;;;EAGC,oBCIM;EDHN,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAMA;EACC,wBAAA;EACA,qBAAA;AAHD;;AAOC;EEfA,aAAA;EACA,sBAAA;EACA,uBFcqB;EEbrB,uBFa6B;EAC5B,WAAA;EACA,aAAA;AADF;AAGE;EACC,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AADH;AAGG;EAEC,gBAAA;EACA,qBCpCO;ADkCX;AAME;EACC,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AAJH;AAMG;EAEC,gBAAA;EACA,qBCjDO;AD4CX;AAUC;EACC,oBAAA;EACA,iBAAA;EACA,WAAA;AARF;AAUE;EE1DD,aAAA;EACA,8BF0DgB;EEzDhB,mBFyD+B;EAC7B,UAAA;AANH;AAWG;EACC,cC5DQ;ADmDZ;AAcC;EACC,WAAA;EACA,aAAA;AAZF;AAcE;EACC,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAZH;AAcG;EAEC,gBAAA;EACA,qBCvFO;AD0EX;AAoBC;EACC,wBAAA;AAlBF;AAqBC;EEjGA,aAAA;EACA,8BFiGe;EEhGf,uBFgG8B;EAC7B,WAAA;AAjBF;AAoBC;EEhGA,aAAA;EACA,sBAAA;EACA,8BF+FqB;EE9FrB,uBF8FoC;EACnC,SAAA;AAfF;AAkBC;EAIC,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBC/GM;EDgHN,yBAAA;EACA,cCrHS;EDsHT,mBAAA;AAnBF;AAsBC;EACC,oCAAA;EACA,sBAAA;AApBF;AAuBC;EACC,iCAAA;EACA,yBAAA;EACA,oCAAA;AArBF;AAwBC;EACC,oCAAA;EACA,yBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AAtBF;AAyBC;EE5IA,aAAA;EACA,yBF4Ie;EE3If,mBF2IyB;EACxB,WAAA;EACA,QAAA;AArBF;AAwBC;EACC,yBCpJS;EDqJT,WCjJM;AD2HR;AAyBC;EEvJA,aAAA;EACA,2BFuJe;EEtJf,mBFsJ2B;AArB5B;;AA0BA;EE7JC,aAAA;EACA,uBF6Jc;EE5Jd,mBF4JsB;EACtB,gBAAA;AArBD;AAuBC;EAIC,cCnKW;EDoKX,gBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;AAxBF;AAsCC;EACC,yBAAA;EACA,gCAAA;AApCF;;AAwCA;EACC,cC3LW;ADsJZ;AAuCC;EAEC,cC/LU;ADyJZ;AAyCC;EExMA,aAAA;EACA,uBFwMe;EEvMf,mBFuMuB;EACtB,YAAA;EACA,2CAAA;EACA,cCtMU;ADiKZ;AAwCC;EAEC,YAAA;EACA,cCnNS;EDoNT,gCAAA;AAvCF;;AA4CC;EACC,aAAA;EACA,eAAA;AAzCF;AA4CC;EACC,mBAAA;EACA,uBAAA;EACA,iCAAA;AA1CF;AA6CC;EACC,aAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;AA3CF;;AA+CA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AA5CD;AA8CC;EACC,eAAA;EACA,yDAAA;AA5CF;AA+CC;EACC,gCAAA;EACA,yBAAA;EACA,oEAAA;AA7CF;AAgDC;EACC,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,yDAAA;AA9CF;;AAkDA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,wCAAA;AA/CD;;AAkDA;EACC,kBAAA;EACA,eAAA;EACA,oCAAA;AA/CD;;AAkDA;EACC,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,8BAAA;AA/CD;;AAkDA;EEvRC,aAAA;EACA,uBFuRc;EEtRd,mBFsRsB;EACtB,QAAA;AA7CD;;AAgDA;EACE,aAAA;AA7CF;;AAgDA;EACC,cAAA;AA7CD;;AAgDA;EACC,yBCtSU;EDuSV,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AA7CD;;AAgDA;EACC,yBC1SW;ED2SX,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA7CD;;AAgDA;;EAGE,wBAAA;AA9CF;;AAmDA,6DAAA;AACA;;EAEC,4BAAA;AAhDD;;AAmDA;EACC,qBAAA;AAhDD","sourcesContent":["@import './sass/globals/globals.scss';\n@import './sass/globals/mixins.scss';\n\nbody,\nhtml,\n#root {\n\tfont-family: $font;\n\twidth: 100%;\n\theight: 100%;\n}\n\n::-webkit-scrollbar {\n\twidth: 0px;\n}\n\n// remove scrollbars\n* {\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\t\n}\n\n.form {\n\t&-input {\n\t\t@include flexColumn(center, flex-start);\n\t\twidth: 100%;\n\t\tmargin: 0.5em;\n\n\t\t& input {\n\t\t\tpadding: 0.64em;\n\t\t\tborder-radius: 0.3em;\n\t\t\tborder: 1px solid #dcdcdc;\n\t\t\tmargin-top: 0.3em;\n\n\t\t\t&:active,\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: none;\n\t\t\t\tborder-color: $dark-red;\n\t\t\t}\n\t\t}\n\n\t\t& select {\n\t\t\tpadding: 0.4em;\n\t\t\tborder-radius: 0.3em;\n\t\t\tborder: 1px solid #dcdcdc;\n\t\t\tmargin-top: 0.3em;\n\n\t\t\t&:active,\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: none;\n\t\t\t\tborder-color: $dark-red;\n\t\t\t}\n\t\t}\n\t}\n\n\t&-select-custom{\n\t\tborder-radius: 0.5em;\n\t\tmargin-top: 0.3em;\n\t\twidth: 100%;\n\n\t\t&-label {\n\t\t\t@include flex(space-between, center);\n\t\t\tgap: 0.5em;\n\n\t\t\t&-primary {\n\t\t\t}\n\n\t\t\t&-secondary {\n\t\t\t\tcolor: $dark-grey;\n\t\t\t}\n\t\t}\n\t}\n\n\t&-area {\n\t\twidth: 100%;\n\t\tmargin: 0.5em;\n\n\t\t& textarea:not(.w-md-editor-text-input) {\n\t\t\tpadding: 1em;\n\t\t\tborder-radius: 0.5em;\n\t\t\tborder: 1px solid #dcdcdc;\n\t\t\tmargin-top: 0.3em;\n\t\t\tmin-height: 11em;\n\t\t\tmax-height: 11em;\n\n\t\t\t&:active,\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: none;\n\t\t\t\tborder-color: $dark-red;\n\t\t\t}\n\t\t}\n\t}\n\n\n\n\t&-check {\n\t\tmargin: .5em !important;\n\t}\n\n\t&-row {\n\t\t@include flex(space-between, flex-start);\n\t\twidth: 100%;\n\t}\n\n\t&-column {\n\t\t@include flexColumn(space-between, flex-start);\n\t\tflex: 1;\n\t}\n\n\t&-action,\n\t&-action:focus,\n\t&-action:hover,\n\t&-action:active {\n\t\talign-self: flex-end;\n\t\toutline: none;\n\t\tbox-shadow: none !important;\n\t\tbackground-color: $white;\n\t\tborder: 1px solid $dark-red;\n\t\tcolor: $dark-red;\n\t\tpadding-inline: 2em;\n\t}\n\n\t&-action-primary {\n\t\tbackground-color: $dark-red !important;\n\t\tcolor: $white !important;\n\t}\n\n\t&-action-secondary {\n\t\tbackground-color: $white !important;\n\t\tcolor: $shadow-color !important;\n\t\tborder: $shadow-color 1px solid !important;\n\t}\n\n\t&-action-cancel {\n\t\tbackground-color: inherit !important;\n\t\tcolor: $dark-grey !important;\n\t\ttext-decoration: underline;\n\t\tborder: none;\n\t\toutline: none;\n\t\tbox-shadow: none !important;\n\t}\n\n\t&-action-group {\n\t\t@include flex(flex-end, center);\n\t\twidth: 100%;\n\t\tgap: 1em;\n\t}\n\n\t&-action:hover {\n\t\tbackground-color: $dark-red;\n\t\tcolor: $white;\n\t}\n\n\t&-radio-group {\n\t\t@include flex(flex-start, center);\n\t}\n\n}\n\n.pagination-container {\n\t@include flex(center, center);\n\tmargin-bottom: 0;\n\n\t& > li > a,\n\t& > li > a:hover,\n\t& > li > a:active,\n\t& > li > a:focus {\n\t\tcolor: $logo-color;\n\t\tbox-shadow: none;\n\t\toutline: none;\n\t\tborder: none;\n\t\tbackground-color: inherit;\n\t\tpadding: 6px;\n\t\tborder-radius: 0 !important;\n\t\tbox-sizing: border-box;\n\t}\n\n\t// & > li > a:hover,\n\t// & > li > a:focus {\n\t// \tborder-bottom: 1px solid $logo-color;\n\t// }\n\n\t// & > li > a:active,\n\t// & > li > a:focus {\n\t// \tcolor: $dark-grey;\n\t// \tborder-bottom: 1px solid $dark-grey;\n\t// }\n\n\t&-selected {\n\t\tcolor: $dark-grey !important;\n\t\tborder-bottom: 1px solid $logo-color;\n\t}\n}\n\n.nav {\n\tcolor: $dark-grey;\n\n\t&-link,\n\t&-link:hover {\n\t\tcolor: $dark-grey;\n\t}\n\n\t&-tabs {\n\t\t@include flex(center, center);\n\t\tborder: none;\n\t\tborder-bottom: 1px solid $grey !important;\n\t\tcolor: $dark-grey;\n\t}\n\n\t&-tabs &-link.active,\n\t&-tabs &-link:hover {\n\t\tborder: none;\n\t\tcolor: $dark-red;\n\t\tborder-bottom: 2px solid $dark-red;\n\t}\n}\n\n.form-check-input-custom{\n\tinput[type=checkbox], input[type=radio] {\n\t\tmargin: .3em;\n\t\tcursor: pointer;\n\t}\n\n\tinput[type=checkbox]:checked, input[type=radio]:checked {\n\t\tborder-color: black;\n\t\tbackground-color: black;\n\t\tbackground-image: none !important;\n\t}\n\n\tinput[type=checkbox]:focus, input[type=radio]:focus {\n\t\toutline: none;\n\t\tbox-shadow: none !important;\n\t\tbackground-image: none !important;\n\t\tborder-color: black !important;\n\t}\n}\n\n.form-custom-switch {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1em;\n\n\tinput[type=checkbox] {\n\t\tcursor: pointer;\n\t\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n\t}\n\n\tinput[type=checkbox]:checked {\n\t\tborder-color: $dark-grey !important;\n\t\tbackground-color: #4e7da2;\n\t\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\") !important;\n\t}\n\n\tinput[type=checkbox]:focus {\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\tborder-color: $dark-grey !important;\n\t\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n\t}\n}\n\n.check-group-line{\n\talign-self: center;\n\twidth: 3em;\n\tmargin: .6em;\n\tborder-top: 1px solid rgb(234, 234, 239);\n}\n\n.draft-badge{\n\tmargin-left: .5em;\n\tcursor: default;\n\tbackground-color: $dark-red !important;\n}\n\n.input-info-error {\n\tmargin-top: 0.25rem;\n\tfont-size: 0.875em !important;\n\tcolor: #dc3545;\n\tfont-weight: normal !important;\n}\n\n.form-subgroup{\n\t@include flex(center, center);\n\tgap: 1em;\n}\n\nbutton[data-name=checked-list], button[data-name=code] {\n  display: none;\n}\n\n#react-select-3-listbox{\n\tz-index: 99999;\n}\n\n.copy-clipboard-button {\n\tbackground-color: $dark-red;\n\tcolor: white;\n\tborder: none;\n\toutline: none;\n\tbox-shadow: none;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-content: center;\n}\n\n.copy-clipboard-button:hover, .copy-clipboard-button:focus {\n\tbackground-color: $dark-grey;\n\tcolor: white;\n\tborder: none;\n\toutline: none;\n\tbox-shadow: none;\n}\n\n.webpack-dev-server-client-overlay-div,\n#webpack-dev-server-client-overlay\n{\n  display: none !important;\n}\n\n\n\n/* Ensure the form area holding the editor expands natively */\n.markdown-form-area .content,\n.markdown-form-area .tag {\n\tdisplay: contents !important;\n}\n\n.markdown-form-area .list {\n\tpadding: 0 !important;\n}\n\n// width: 100% !important;","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
